import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

/** 보호구 수령현황 조회 기본 기간 (3년 전 ~ 오늘) */
export const GetDefaultDateRange = () => ({
  dateFrom: dayjs().subtract(3, 'year').format('YYYY-MM-DD'),
  dateTo: dayjs().format('YYYY-MM-DD'),
});

const initialState = {
  /** 홈 M_Equipment 메뉴 뱃지: '수령하기' = 미서명 수령 건 존재 */
  equipReceiptAlarm: '',
  ...GetDefaultDateRange(),
};

const equipmentSlice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    setEquipReceiptAlarm(state, action) {
      state.equipReceiptAlarm = action.payload ?? '';
    },
    clearEquipReceiptAlarm(state) {
      state.equipReceiptAlarm = '';
    },
    setEquipReceiptDateRange(state, action) {
      const { dateFrom, dateTo } = action.payload ?? {};
      if (dateFrom != null) state.dateFrom = dateFrom;
      if (dateTo != null) state.dateTo = dateTo;
    },
    resetEquipReceiptDateRange(state) {
      const defaults = GetDefaultDateRange();
      state.dateFrom = defaults.dateFrom;
      state.dateTo = defaults.dateTo;
    },
  },
});

export const EquipmentActions = equipmentSlice.actions;
export default equipmentSlice.reducer;
